import { Image, Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AuthWrapper } from 'src/components';
import OnboardingImage from 'src/assets/images/onboarding.png';
import { OnboardingForm } from 'src/components';
import { useDocumentTitle } from '@mantine/hooks';

const OnboardingPage = (): JSX.Element => {
  const [t] = useTranslation('auth');

  useDocumentTitle(t('onboardingPageTitle'));

  return (
    <AuthWrapper
      leftColumn={
        <Flex direction={'column'} align={'center'}>
          <Image maw={400} mx={'auto'} radius={'md'} src={OnboardingImage} alt={`${t('onboardingImage')}`} style={{ filter: 'hue-rotate(240deg)' }}  />
        </Flex>
      }
      rightColumn={<OnboardingForm />}
    />
  );
};

export default OnboardingPage;
